import { useState, useEffect } from 'react';
import { Link } from 'react-router';
import ScreenReaderOnly from '../../accessibility/ScreenReaderOnly';

import styles from './progressbar-with-goals.module.less';

export const Goal = ({ index, goal, originalGoal, maxGoal, collectedByGivers, matchingAmount, className }) => {
    const { startAmount, amount: endAmount } = goal;
    const totalCollected = collectedByGivers + matchingAmount;
    const amountInGoal = endAmount - startAmount;
    const shareOfCollectedInGoal = amountInGoal / maxGoal;
    const goalWidthInPercent = shareOfCollectedInGoal * 100;

    const maxMatchingCanBeUsed = Math.min(matchingAmount - startAmount, amountInGoal);
    const matchingAmountUsedInGoal = Math.min(Math.max(maxMatchingCanBeUsed, 0), amountInGoal);
    const maxCollectedCanBeUsed = Math.min(totalCollected - startAmount, amountInGoal);
    const collectedAmountUsedInGoal = Math.min(
        Math.max(maxCollectedCanBeUsed - matchingAmountUsedInGoal, 0),
        amountInGoal
    );

    const matchingProgress = matchingAmountUsedInGoal / amountInGoal;
    const matchingProgressInPercent = matchingProgress * 100;
    const collectedProgress = collectedAmountUsedInGoal / amountInGoal;
    const collectedProgressInPercent = collectedProgress * 100;

    const isStretchGoal = startAmount >= originalGoal;

    // Animasjonen blir litt vel kjapp når man har mange delmål, så vi smidger den litt
    const SMIDGE_FACTOR = isStretchGoal ? 1.5 : 1;

    const [matchingProgressWidth, setMatchingProgressWidth] = useState(0);
    const [collectedProgressWidth, setCollectedProgressWidth] = useState(0);

    useEffect(() => {
        setMatchingProgressWidth(matchingProgressInPercent);
        setCollectedProgressWidth(collectedProgressInPercent);
    }, [matchingProgressInPercent, collectedProgressInPercent]);

    const content = (
        <>
            <div
                className={[
                    styles.progressInGoalMatching,
                    collectedProgressWidth === 0 ? styles.roundedCorners : '',
                ].join(' ')}
                style={{
                    width: `${matchingProgressWidth}%`,
                    transitionDuration: `${shareOfCollectedInGoal * matchingProgress * SMIDGE_FACTOR}s`,
                    transitionDelay: `${(startAmount / maxGoal) * SMIDGE_FACTOR}s`,
                    transitionTimingFunction: index === 0 ? 'ease-in' : 'linear',
                }}
            />
            <div
                className={styles.progressInGoal}
                style={{
                    width: `${collectedProgressWidth}%`,
                    transitionDuration: `${shareOfCollectedInGoal * collectedProgress * SMIDGE_FACTOR}s`,
                    transitionDelay: `${(startAmount / maxGoal) * SMIDGE_FACTOR}s`,
                    transitionTimingFunction:
                        collectedProgressWidth < 100 || (totalCollected > endAmount && endAmount === maxGoal)
                            ? 'ease-out'
                            : 'linear',
                }}
            />
        </>
    );

    if (goal.project_update_id) {
        return (
            <Link
                to={`/project/${goal.project_id}/update#${goal.project_update_id}`}
                label={'Oppdatering for delmål'}
                className={`${styles.goal} ${isStretchGoal ? styles.stretchGoal : ''}`}
                style={{ width: `${goalWidthInPercent}%` }}
            >
                <ScreenReaderOnly>Åpne oppdatering for delmål</ScreenReaderOnly>
                {content}
            </Link>
        );
    } else {
        return (
            <span
                className={`${styles.goal} ${isStretchGoal ? styles.stretchGoal : ''} ${className ? className : ''}`}
                style={{ width: `${goalWidthInPercent}%` }}
            >
                {content}
            </span>
        );
    }
};
